import React from "react";
import { Text, Link } from "@react-pdf/renderer";
import { makePdfStyleSheet } from "../styles";

interface DadosTenantProps {
  nome: string;
  endereco: string;
  email: string | null;
  fone: string | null;
}

function DadosTenant(dadosTenant: DadosTenantProps) {
  const stylesCertidao = makePdfStyleSheet();

  return (
    <>
      {dadosTenant.endereco ? (
        <Text>
          <Text style={stylesCertidao.fontBold}>Endereço: </Text>
          {dadosTenant.endereco}
        </Text>
      ) : null}

      {dadosTenant.email ? (
        <Text>
          <Text style={stylesCertidao.fontBold}>E-mail: </Text>
          <Link src={`mailto:${dadosTenant.email}`}>{dadosTenant.email}</Link>
        </Text>
      ) : null}

      {dadosTenant.fone ? (
        <Text>
          <Text style={stylesCertidao.fontBold}>Fone: </Text>
          {dadosTenant.fone}
        </Text>
      ) : null}
    </>
  );
}

export default DadosTenant;
